Controller = App.loadClass 'core::Angular/Controller'

class exports.ConfirmationRow extends Controller
    constructor: (@scope, @transitions, @state, @generate, @data, @loader, @window, @modal) ->
        super(@scope, @transitions)
        # This object handles dynamic class loading for the table headers and sorting them
        @scope.sorting =
            # set default for ng-class
            classes:
                default: 'fa-sort'
                up: 'fa-sort-asc'
                down: 'fa-sort-desc'

            # set options for sorting
            columns:
                year: false
                status: false
                farmName: true

            # set active default
            active: 'fa-sort-desc'

        # set default sort column
        @scope.sortColumn = 'farmName'
        # setup for resizing
        @scope.resize = 0
        @scope.resizeTable = () => @scope.resize++
        # Functions
        @scope.clickableHeaderSort = @clickableHeaderSort
        @window.confirmationStatusUpdate = @confirmationStatusUpdate
        @window.conversionRequestSent = @conversionRequestSent

        @scope.$on '$destroy', () =>
            # remove functions from window
            @window.confirmationStatusUpdate = null
            @window.conversionRequestSent = null

    conversionRequestSent: (data) =>
        @scope.$emit 'uploads:processing'

    determineStatus: (parent) =>
        # check confirm button state
        # determine status
        return @generate.determineStatus(parent).then (response) =>
            parent.data.status = response.data.data
            @updateTab()

    headerSort = (column, a, b) ->
        # set up
        result = strnatcasecmp(a[column], b[column])
        multisort = 0: 'farmName', 1: 'year', 2: 'status'

        ## Use an additional sort if the strings are equal ###
        ## Sort by each column left->right until we get a different result ###
        if result is 0
            for index, col of multisort
                # dont check a column we already looked at
                if col isnt column
                    result = strnatcasecmp(a[col], b[col])
                    if result isnt 0
                        return result

        # if they aren't equal, return result
        return result

    clickableHeaderSort: (column) =>
        # check if we have already sorted this column
        if @scope.sortColumn isnt column
            # we just sorted by this last time
            # we need to set the old header class to default
            @changeHeaderIcon(column)
            # set active state to down for new sort header
            @scope.sorting.active = @scope.sorting.classes.down
            # continue
            @scope.sortColumn = column
            @scope.parents.sort(headerSort.bind(null, column))
        else
            # we are sorting in reverse order for the same header as last time
            @scope.parents.reverse()
            # we need to set the active icon for up
            @changeHeaderIcon(column)

    changeHeaderIcon: (column) =>
        # set active class based on direction
        # simple logic to determine which way the arrow should be pointing

        if @scope.sorting.active is @scope.sorting.classes.down
            @scope.sorting.active = @scope.sorting.classes.up
        else
            @scope.sorting.active = @scope.sorting.classes.down

        # set active column class to whatever active should be (upordown)
        @scope.sorting.columns[column] = true

        # set all others to default
        for cname, v of @scope.sorting.columns
            # dont default the active column
            if cname isnt column
                @scope.sorting.columns[cname] = false

    confirmationStatusUpdate: (data) =>
        if @scope.parents?
            # update parents
            for parent in @scope.parents when parent.parent_id is data.parents_id
                parent.data.status = if data.success then 'Done' else 'Failed'
                parent.loading = false
            # apply since this happens asynchronously
            @scope.$apply()

    updateTab: () =>
        confirmed = 0

        for parent in @scope.parents
            if parent.data.status in ['Done', 'Processing']
                confirmed += 1

        @scope.tabs[@scope.tab].unconfirmed = @scope.parents.length - confirmed

    updateChildrenYear: (parent) =>
        @generate.updateYears(parent.parent_id, parent.data.selected.year).then () =>
            parent.loading = true
            @checkSelectionsForConfirm(parent).then () =>
                parent.loading = false

    updateChildrenCrop: (parent, crop, relationshipId) =>
        @generate.updateChildrenCrop(parent.parent_id, crop.id, relationshipId).then () =>
            parent.loading = true
            @checkSelectionsForConfirm(parent).then () =>
                parent.loading = false

    updateChildrenNumberOfProducts: (parent, numberOfProducts, relationshipId) =>
        @generate.updateChildrenNumberOfProducts(parent.parent_id, numberOfProducts, relationshipId).then () =>
            parent.loading = true
            @checkSelectionsForConfirm(parent).then () =>
                parent.loading = false

    updateChildrenSeedCompanies: (parent, product) =>
        if product?.selected?.seedCompany?.id and product.id
            @generate.updateChildrenSeedCompanies(product.selected.seedCompany.id, product.id).then () =>
                product.selected.product = null
                parent.loading = true
                @checkSelectionsForConfirm(parent).then () =>
                    parent.loading = false

    updateChildrenProduct: (product, parent) =>
        @generate.updateChildrenProduct(product.selected.product, product.id).then () =>
            parent.loading = true
            @checkSelectionsForConfirm(parent).then () =>
                parent.loading = false

    getSeedCompaniesByCrop: (product, crop, reset = true) =>
        if reset
            # reset selections
            product.selected.seedCompany = null
            product.selected.product = null

        # fetch seed companies
        @generate.getSeedCompaniesByCrop(crop.id).then (response) =>
            if response?.data?.status?.type is 'success'
                # set seed companies list
                product.required.seedCompanies = response.data.data

    getProductsBySeedCompany: (product, reset = true) =>
        @generate.getProductsBySeedCompany(product.selected.crop.id, product.selected.seedCompany.id).then (response) =>
            if response?.data?.status?.type is 'success'
                if reset
                    # reset selection
                    product.selected.product = null
                # set the products list
                product.required.products = response.data.data

    clearCompanySelections: (product) =>
        # clear the selected company and product data
        product.selected.seedCompany = null
        @clearProductSelection(product)

    clearProductSelection: (product) =>
        # clear selected product
        product.selected.product = null

    confirm: (parent) =>
        # switch status to processing, and disable confirm button
        parent.data.status = 'Processing'
        parent.loading = true
        parent.disabled.confirm = true
        @generate.confirm(parent.parent_id).then (response) =>
            # check for unconfirmed files
            @updateTab()

    launchAddProduct: (row, parent) =>
        cropId = row.selected.crop.id
        @modal.open
            windowClass: 'smaller_dialog'
            templateUrl: 'backend/grower/products/create'
            controller: 'Planting.Controllers.AddGrowerProductController'
            resolve:
                seedCompany: () -> row.selected.seedCompany
                autoSelect: () -> crop: cropId
        .result
        .then (product) =>
            row.selected.product = product
            row.selected.product.isGrower = true
            # refetch products from the backend so we load the newly created one
            @scope.getProductsBySeedCompany(row, false)
            @scope.updateChildrenProduct(row, parent)

    groupProducts: (product) =>
        return if product.isGrower then 'Your Custom' else undefined

    paginate: (table_state, @cnt) =>
        if @reload
            @reload = false
            table_state.pagination.start = 0
            table_state.pagination.number = 25

        @loadParentData table_state.pagination.start or 0, table_state.pagination.number or 25
            .then (result) =>
                table_state.pagination.totalItemCount = result
                table_state.pagination.numberOfPages = Math.ceil(result / table_state.pagination.number)
            .catch (err) =>
                @setAlert
                    msg: 'Error loading data'
                    type: 'error'
            .finally () =>
                @scope.resize++
                @loader.hideAll()
                return true

